import type { EventName } from "@lit/react";
import { CrudEdit as CrudEditElement, } from "@vaadin/crud/vaadin-crud-edit.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CrudEditElement, };
export type CrudEditEventMap = Readonly<{
    onEdit: EventName<CustomEvent<unknown>>;
}>;
const events = { onEdit: "edit" } as CrudEditEventMap;
export type CrudEditProps = WebComponentProps<CrudEditElement, CrudEditEventMap>;
export const CrudEdit = createComponent({
    elementClass: CrudEditElement, events, react: React, tagName: "vaadin-crud-edit"
});
